import Footer from "../../components/Footer/Footer";
import MainMenu from "../../components/MainMenu/MainMenu";
import ToastContainer from "../../components/ToastContainer/ToastContainer";
import DynamicModalContainer from "../../components/DynamicModalContainer/DynamicModalContainer";
import { useRetrieveUser } from "../../hooks/useRetrieveUser";

type Props = {
  children: JSX.Element
};

function PageWrapper({children}: Props) {

  useRetrieveUser();

  return (
    <div className="light-black">
      <MainMenu />
      <div className="container p-3 max-w-7xl md:px-16 md:pt-7 mx-auto flex flex-col min-h-screen">
        { children }
      </div>
      <Footer />
      <ToastContainer />
      <DynamicModalContainer />
    </div>
  );
}

export default PageWrapper;
